var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0.5L0.166504 13.5L8.83317 18.2233V31.2233L23.9998 39.5L39.1665 31.2233V18.2233L43.4998 15.8617V30.8333H47.8332V13.5L23.9998 0.5ZM38.7765 13.5L23.9998 21.56L9.22317 13.5L23.9998 5.44L38.7765 13.5ZM34.8332 28.645L23.9998 34.56L13.1665 28.645V20.585L23.9998 26.5L34.8332 20.585V28.645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCap);
export default __webpack_public_path__ + "static/media/icon_cap.3edfca0ac9b0f469be860d413836c4d9.svg";
export { ForwardRef as ReactComponent };